<template>
  <div class="editwork">
    <el-dialog title="编辑工作经历" :close-on-click-modal="false" :visible.sync="display" @close='closeDialog'>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="起始时间" prop="start_date">
          <el-col :span="11">
            <el-form-item label="" prop="start_date">
              <el-date-picker v-model="form.start_date" format="yyyy/MM" type="month" placeholder="选择日期"
                value-format="yyyy/MM" style="width:100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="line">-</el-col>
          <el-col :span="11">
            <el-form-item label="" prop="end_date">
              <el-date-picker v-model="form.end_date" type="month" placeholder="选择日期" value-format="yyyy/MM"
                style="width:100%;" ref="endDate" :picker-options="pickerOptions" :format="dateFormat"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="企业名称" prop="company_name">
          <el-input v-model="form.company_name" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="所属行业" prop="industry_id">
          <el-select v-model="form.industry_id" style="width:100%;">
            <el-option v-for="item in industrys" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业性质" prop="">
          <el-select v-model="form.company_type_id" style="width:100%;">
            <el-option v-for="item in coTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业人数" prop="">
          <el-select v-model="form.company_size_id" style="width:100%;">
            <el-option v-for="item in coSizes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在部门">
          <el-input v-model="form.department" placeholder="请输入所在部门"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-input v-model="form.position" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="职位描述">
          <el-input v-model="form.description" type="textarea" placeholder="请输入职位描述"
            :autosize="{ minRows: 3, maxRows: 5}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    coSizeList
  } from '~/static/basicData';
  import {
    getIndustryList,
    getCoTypeList
  } from '~/api/common';
  export default {
    components: {},
    props: {
      data: {
        type: Object,
        default: {}
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      var greaterZero = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请选择一个选项'));
        } else {
          callback();
        }
      };
      return {
        industrys: [],
        coTypes: [],
        coSizes: coSizeList,
        form: {},
        display: false,
        rules: {
          start_date: [{
            required: true,
            message: '请选择开始日期',
            trigger: 'change'
          }],
          end_date: [{
            required: true,
            message: '请选择结束日期',
            trigger: 'change'
          }],
          company_name: [{
            required: true,
            message: '请输入公司',
            trigger: 'change'
          }],
          position: [{
            required: true,
            message: '请输入职位',
            trigger: 'change'
          }],
          industry_id: [{
            required: true,
            validator: greaterZero,
            message: '请选择行业',
            trigger: 'change'
          }],
          company_type_id: [{
            validator: greaterZero,
            message: '请选择公司性质',
            trigger: 'change'
          }],
          company_size_id: [{
            validator: greaterZero,
            message: '请选择公司规模',
            trigger: 'change'
          }],
        },
        pickerOptions: {
          shortcuts: [{
            text: '至今',
            onClick(picker) {
              const date = new Date('1900-01');
              picker.$emit('pick', date);
            }
          },
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }
          ]
        }
      };
    },
    watch: {
      data: function (value) {
        this.form = Object.assign({}, value);
        if(this.form.company_type_id == 0){
          this.form.company_type_id = '';
        }
        if(this.form.company_size_id == 0){
          this.form.company_size_id = '';
        }
        if (this.form.end_date == '至今') {
          this.form.end_date = new Date('1900-01');
        }
      },
      visible: function (value) {
        this.display = value;
        if (this.display && this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      },
    },
    mounted() {
      this.getIndustrys();
      this.getCoTypes();  
    },
    computed: {
      dateFormat() {
        if (new Date(this.form.end_date).getFullYear() == 1900) {
          return '至今';
        }
        return 'yyyy/MM';
      },
    },
    methods: {
      getIndustrys(){
        getIndustryList().then(m => {
          if(m.errcode === 0){
            this.industrys = [];
            m.data.forEach(m => {
              this.industrys.push({
                value: m.PuIndustryID,
                label: m.IndustryName
              });
            });
          }      
        });
      },

      getCoTypes(){
        getCoTypeList().then(m => {
          if(m.errcode === 0){
            this.coTypes = [];
            m.data.forEach(m => {
              this.coTypes.push({
                value: m.PuBasicdataID,
                label: m.DaName
              });
            });
          }      
        });
      },

      industryChange(value) {
        this.form.industry_id = value > 0 ? value : 0;
        let obj = this.$refs.industry.options.find((item) => {
          return item.PuBasicdataID === value;
        });
        this.form.industry = obj.DaName;
      },

      companyTypeChange(value) {
        this.form.company_type_id = value > 0 ? value : 0;
        let obj = this.$refs.coType.options.find((item) => {
          return item.PuBasicdataID === value;
        });
        this.form.company_type = obj.DaName;
      },

      companySizeChange(value) {
        this.form.company_size_id = value > 0 ? value : 0;
        let obj = this.$refs.coSize.options.find((item) => {
          return item.PuBasicdataID === value;
        });
        this.form.company_size = obj.DaName;
      },

      cancel() {
        this.display = false;
      },
      
      confirm() {
        this.$refs['form'].validate((valid) => {
          if (!valid) return false;
          this.display = false;
          this.form.company_size_id = this.form.company_size_id == '' ? 0 : parseInt(this.form.company_size_id);
          this.form.company_type_id = this.form.company_size_id == '' ? 0 : parseInt(this.form.company_type_id);
          this.$emit('change', this.form);
        });
      },
      
      closeDialog() {
        this.$emit('visibleChange', false);
      },
    }
  };
</script>

<style lang="scss" scoped>
  .line {
    text-align: center;
  }
</style>